/**
 * @generated SignedSource<<7a1b204bdbea4603b2f3f43eebc3b7c6>>
 * @relayHash 15c198440fb42fe98324538a763d7e6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bea0cf7e0518c5227d2a359d5d2440cfddc2640f3c73c666b189335b6e5f4f25

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkSuggestionsActionInput = {
  cloudId: string;
  taskId: string;
};
export type useWorkSuggestionsAction_WorkSuggestionsSnoozeTaskMutation$variables = {
  input: WorkSuggestionsActionInput;
};
export type useWorkSuggestionsAction_WorkSuggestionsSnoozeTaskMutation$data = {
  readonly workSuggestions: {
    readonly snoozeTask: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useWorkSuggestionsAction_WorkSuggestionsSnoozeTaskMutation = {
  response: useWorkSuggestionsAction_WorkSuggestionsSnoozeTaskMutation$data;
  variables: useWorkSuggestionsAction_WorkSuggestionsSnoozeTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "WorkSuggestionsMutation",
    "kind": "LinkedField",
    "name": "workSuggestions",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "WorkSuggestionsActionPayload",
        "kind": "LinkedField",
        "name": "snoozeTask",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useWorkSuggestionsAction_WorkSuggestionsSnoozeTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWorkSuggestionsAction_WorkSuggestionsSnoozeTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "bea0cf7e0518c5227d2a359d5d2440cfddc2640f3c73c666b189335b6e5f4f25",
    "metadata": {},
    "name": "useWorkSuggestionsAction_WorkSuggestionsSnoozeTaskMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "9fe780a3add272ac00a130c9ff20d911";

export default node;
